import { useTheme } from "@mui/material";
import Typography from "components/basic/typography";

interface QuoteInfoListProps {
  items: string[];
  /** "plain" stacks lines; "bulleted" renders an unordered list. */
  variant?: "plain" | "bulleted";
}

/**
 * Renders a list of estimate detail strings either as stacked plain lines
 * (e.g. INCLUSIONS) or as a bulleted list (e.g. ASSUMPTIONS, TERMS).
 */
const QuoteInfoList: React.FC<QuoteInfoListProps> = ({
  items,
  variant = "plain",
}) => {
  const theme = useTheme();

  if (!items.length) {
    return null;
  }

  if (variant === "bulleted") {
    return (
      <ul style={{ margin: 0, paddingLeft: theme.spacing(3) }}>
        {items.map((item, index) => (
          <li key={index}>
            <Typography variant="body2">{item}</Typography>
          </li>
        ))}
      </ul>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {items.map((item, index) => (
        <Typography key={index} variant="body2">
          {item}
        </Typography>
      ))}
    </div>
  );
};

export default QuoteInfoList;
